import { Checkbox, Group, Paper, Stack, Text } from "@mantine/core";
import { useCallback, useMemo, type ChangeEvent } from "react";
import type { TissueCypherSignOutProposal } from "../../services/reflexPanels.service";

interface TissueCypherProposalOptionProps {
  proposal: TissueCypherSignOutProposal;
  checked: boolean;
  disabled: boolean;
  onToggle: (proposalKey: string, checked: boolean) => void;
}

export default function TissueCypherProposalOption({
  proposal,
  checked,
  disabled,
  onToggle,
}: TissueCypherProposalOptionProps) {
  const componentSummary = useMemo(
    () =>
      proposal.targetPanel.components
        .map((component) => `${component.stainCode} ×${component.quantity}`)
        .join(" · "),
    [proposal.targetPanel.components]
  );
  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      onToggle(proposal.proposalKey, event.currentTarget.checked);
    },
    [onToggle, proposal.proposalKey]
  );

  return (
    <Paper withBorder p="md" radius="md">
      <Group wrap="nowrap" align="flex-start">
        <Checkbox
          aria-label={`Order Tissue Cypher for specimen ${proposal.specimenNumber}`}
          checked={checked}
          disabled={disabled}
          onChange={handleChange}
        />
        <Stack gap={3}>
          <Text fw={600}>Tissue Cypher panel</Text>
          <Text size="sm">
            Specimen {proposal.specimenNumber} · ICD{" "}
            {proposal.matchingIcdCodes.join(", ")}
          </Text>
          <Text size="xs" c="dimmed">
            {componentSummary}
          </Text>
        </Stack>
      </Group>
    </Paper>
  );
}
